import type { OrderStatus } from '@runnerboy/types';

export function inr(paise: number | null | undefined, opts: { decimals?: boolean } = {}): string {
  if (paise === null || paise === undefined) return '—';
  const rupees = paise / 100;
  const decimals = opts.decimals ?? !Number.isInteger(rupees);
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: decimals ? 2 : 0, maximumFractionDigits: decimals ? 2 : 0 }).format(rupees);
}

export function volume(ml: number | null | undefined): string {
  if (!ml) return '';
  return ml >= 1000 ? `${(ml / 1000).toFixed(ml % 1000 === 0 ? 0 : 1)} L` : `${ml} ml`;
}

export function timeAgo(iso: string | Date | null | undefined, now = Date.now()): string {
  if (!iso) return '';
  const t = typeof iso === 'string' ? Date.parse(iso) : iso.getTime();
  const s = Math.max(0, Math.round((now - t) / 1000));
  if (s < 45) return 'just now';
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  return new Date(t).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
}

export function clock(iso: string | Date | null | undefined, timeZone = 'Asia/Kolkata'): string {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit', timeZone });
}

export function dateTime(iso: string | Date | null | undefined, timeZone = 'Asia/Kolkata'): string {
  if (!iso) return '';
  return new Date(iso).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', timeZone });
}

export function secondsLeft(iso: string | null | undefined, now = Date.now()): number {
  if (!iso) return 0;
  return Math.max(0, Math.round((Date.parse(iso) - now) / 1000));
}

export const STATUS_TONE: Partial<Record<OrderStatus, 'neutral' | 'brand' | 'accent' | 'success' | 'danger' | 'warning' | 'info'>> = {
  PAYMENT_PENDING: 'warning',
  PLACED: 'info',
  STORE_CONFIRMATION_PENDING: 'warning',
  STORE_ACCEPTED: 'brand',
  RUNNER_SEARCHING: 'brand',
  RUNNER_ASSIGNED: 'brand',
  RUNNER_TO_STORE: 'brand',
  RUNNER_AT_STORE: 'brand',
  ORDER_PREPARING: 'brand',
  READY_FOR_PICKUP: 'accent',
  PICKED_UP: 'accent',
  OUT_FOR_DELIVERY: 'accent',
  RUNNER_NEARBY: 'accent',
  ARRIVED: 'accent',
  HANDOVER_VERIFICATION: 'accent',
  DELIVERED: 'success',
  STORE_REJECTED: 'danger',
  DELIVERY_REFUSED: 'danger',
  RETURN_TO_STORE: 'warning',
  RETURNED: 'neutral',
  CANCELLED: 'neutral',
  REFUND_PENDING: 'warning',
  REFUNDED: 'neutral',
  FAILED: 'danger',
};

export function humanize(code: string): string {
  return code
    .toLowerCase()
    .split('_')
    .map((w, i) => (i === 0 ? w.charAt(0).toUpperCase() + w.slice(1) : w))
    .join(' ');
}
